import { render, staticRenderFns } from "./GocardlessCustomAmount.vue?vue&type=template&id=59f3eec2"
import script from "./GocardlessCustomAmount.vue?vue&type=script&lang=js"
export * from "./GocardlessCustomAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports